import React from "react";
import {Tag} from "depoto-core";
import './TagLabel.css'

type Props = {
  tag: Tag,
  className?: string
}
export const TagLabel: React.FC<Props> = ({ tag, className }) => (
  <div className={`tag-label${className ? ` ${className}` : ''}`} style={{ backgroundColor: tag.color || 'var(--color-base-200)' }}>
    {tag.name}
  </div>
)
